export default __webpack_public_path__ + "assets/images/coin.ac7015.png";